(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('slideshow-container:has([data-drag-indicator])');
    
    containers.forEach(container => {
      const indicator = container.querySelector('[data-drag-indicator]');
      if (!indicator) return;
      
      container.addEventListener('mouseenter', (e) => {
        indicator.classList.add('is-visible');
        updatePosition(e, indicator, container);
      });
      
      container.addEventListener('mousemove', (e) => {
        updatePosition(e, indicator, container);
      });
      
      container.addEventListener('mouseleave', () => {
        indicator.classList.remove('is-visible');
      });
    });
    
    function updatePosition(e, indicator, container) {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      indicator.style.left = x + 'px';
      indicator.style.top = y + 'px';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
